import React from 'react';
import { FaTimes } from 'react-icons/fa'; // Importando o ícone de fechar
import Button from './button';

const Modal = ({ children, isOpen, onClose, onSave, title, subtitle, disabledClose = false }) => {
    if (!isOpen) return null;  // Não renderiza se o modal não estiver aberto

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-20">
            <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-[800px] max-h-[95vh] overflow-y-auto relative">
                
                {/* Título com ícone de fechar */}
                <div className="flex justify-between items-center mb-4">
                    <div>
                        <h2 className="text-xl font-bold">{title}</h2>
                        {subtitle && (
                            <p className="text-gray-600 text-sm">{subtitle}</p>
                        )}
                    </div>
                    {!disabledClose && (
                        <button onClick={onClose} className="text-gray-600 hover:text-gray-900">
                            <FaTimes size={20} /> {/* Ícone de fechar */}
                        </button>
                    )}
                </div>

                {children} {/* Aqui você pode adicionar os campos de entrada para criar o boleto */}

                {/* <div className="flex justify-end space-x-2 mt-4"> */}
                    {/* <Button variant="contained" color="secondary" onClick={onClose}>Fechar</Button> */}
                    {/* <Button onClick={onSave}>Salvar</Button> */}
                {/* </div> */}
            </div>
        </div>
    );
};

export default Modal;
